// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__C1lL3","footer":"ModalFilter_footer__3Bpbt"};